import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMe } from "@chotca/api-client";
import { AppBootLoader } from "@chotca/app-shell";

export function AuthGate({
  children,
}: {
  children: (
    me: NonNullable<ReturnType<typeof useMe>["data"]>,
  ) => React.ReactNode;
}) {
  const loc = useLocation();
  const nav = useNavigate();
  const { data: me, isPending, isError } = useMe();

  React.useEffect(() => {
    if (isPending) return;
    if (isError || !me || me.globalRole !== "ADMIN") {
      const back = loc.pathname + loc.search;
      nav(`/login?redirect=${encodeURIComponent(back)}`, { replace: true });
    }
  }, [isPending, isError, me, loc.pathname, loc.search, nav]);

  if (isPending || !me) return <AppBootLoader />;
  if (me.globalRole !== "ADMIN") return <AppBootLoader />;

  return <>{children(me)}</>;
}
